import { appeler } from './api.js';

/**
 * LES ENVIRONNEMENTS D UN PROJET [contrat 28-CG].
 *
 * FACADE PROPRE, non un ajout a `projets.ts` : la ressource a son contrat et
 * son cycle d evolution. 29-G y ajoutera l etat de deploiement par
 * environnement, 29-H les donnees de configuration visibles. `Projet.tsx` est
 * une vue COMPOSEE -- il consomme cette facade ET celle des projets.
 *
 * `cree_le` EN SNAKE_CASE, jusque dans le type : `/locataires/` porte cette
 * convention [dette 53, decision 2.b de 29-C]. Le contrat serveur est lu tel
 * quel, jamais transpose a la frontiere.
 *
 * L axe est FERME a deux natures cote serveur (CHECK de la 032) comme ici :
 * le bac a sable n en est pas une troisieme [28-CA].
 */
export interface EnvironnementConnu {
  readonly nature: 'test' | 'production';
  readonly cree_le: string;
}

export async function listerEnvironnements(
  espace: string, projet: string,
): Promise<{ readonly environnements: readonly EnvironnementConnu[] }> {
  return appeler<{ environnements: readonly EnvironnementConnu[] }>(
    'GET', `/locataires/${encodeURIComponent(espace)}`
      + `/projets/${encodeURIComponent(projet)}/environnements`);
}
/**
 * LA CONFIGURATION D UN ENVIRONNEMENT [29-H].
 *
 * `valeur` est ABSENTE quand l entree est secrete -- le serveur ne la
 * projette JAMAIS. Le type le dit tel quel plutot que de mentir avec une
 * chaine vide : un secret enregistre ne se relit pas, il se REMPLACE.
 *
 * L environnement se designe par sa NATURE et non par un identifiant : le
 * couple (projet, nature) est l identite publique [28-CC], et la reponse des
 * environnements ne porte deja aucun id.
 */
export interface EntreeConfiguration {
  readonly cle: string;
  readonly secrete: boolean;
  readonly valeur?: string;
  readonly modifie_le: string;
}
const base = (espace: string, projet: string, nature: string): string =>
  `/locataires/${encodeURIComponent(espace)}`
  + `/projets/${encodeURIComponent(projet)}`
  + `/environnements/${encodeURIComponent(nature)}/configuration`;
export async function listerConfiguration(
  espace: string, projet: string, nature: string,
): Promise<{ readonly configuration: readonly EntreeConfiguration[] }> {
  return appeler<{ configuration: readonly EntreeConfiguration[] }>(
    'GET', base(espace, projet, nature));
}
/**
 * VALEUR **OU** SECRET, jamais les deux : miroir du CHECK d exclusion que la
 * base impose. La facade ne compose pas le corps a la place de l appelant --
 * c est l ecran qui sait ce que l utilisateur a saisi.
 */
export async function poserConfiguration(
  espace: string, projet: string, nature: string, cle: string,
  corps: { readonly valeur: string } | { readonly secret: string },
): Promise<{ readonly cle: string; readonly secrete: boolean }> {
  return appeler<{ cle: string; secrete: boolean }>(
    'PUT', `${base(espace, projet, nature)}/${encodeURIComponent(cle)}`, corps);
}
export async function supprimerConfiguration(
  espace: string, projet: string, nature: string, cle: string,
): Promise<{ readonly cle: string; readonly supprimee: boolean }> {
  return appeler<{ cle: string; supprimee: boolean }>(
    'DELETE', `${base(espace, projet, nature)}/${encodeURIComponent(cle)}`);
}
